const currentYear = new Date().getFullYear();

export const EXTENDED_HOLIDAYS_MESSAGE = `Buying as a gift? Full-priced orders placed between November 28th, ${currentYear} and December 9th, ${currentYear} can be returned for a refund until January 6, ${
  currentYear + 1
}.`;
